import { render, staticRenderFns } from "./VehicleModel.vue?vue&type=template&id=ee181114"
import script from "./VehicleModel.vue?vue&type=script&lang=js"
export * from "./VehicleModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports